import React, {Component} from 'react';
import VirtualizedSelect from 'react-virtualized-select';
import '../../node_modules/react-virtualized-select/node_modules/react-select/dist/react-select.css';
import '../../node_modules/react-virtualized/styles.css'
import '../../node_modules/react-virtualized-select/styles.css'
import { getIdValuesLvl2 } from '../components/UserFunctions'
import Modal from 'react-awesome-modal';
import AdvanceSearchModal from './AdvanceSearchModal.js'
import PropTypes from 'prop-types';

class Dropdown_level2 extends Component{
    state = {
        all_val : [],
        tag_selectValue : [],
        bench_selectValue : [],
        scene_selectValue : [],

        tag_options : [],
        scene_options : [],
        bench_options : [],

        remark: [],
        button_status : false,
        view_remark:false,
        view_advance_search : false,

    };

    viewAdvanceSearch(){
        this.setState({
            view_advance_search : true
        })
    }

    viewRemark() {
        this.setState({
            view_remark : true,
        });
      }

    closeModal() {
    this.setState({
        view_remark : false
    });
    }

    onCloseAdvanceSearchModal(){
        this.setState({
            view_advance_search : false
        })
    }

    onTagChange = (select_val) => {
        var scene_arr = [];
        var duplicate_label = [];
        if(select_val != null){
        for (var key in this.state.all_val['tagval']){
            if (this.state.all_val.tagval[key]===select_val.value){
                if (duplicate_label.length>0 && duplicate_label.includes(this.state.all_val.sceneval[key])){
                    //pass
                }
                else{
                    scene_arr.push({value:this.state.all_val.sceneval[key],label:this.state.all_val.scenelabel[key]})
                    duplicate_label.push(this.state.all_val.sceneval[key])
                }
            }
        }
        }


        this.setState({
            tag_selectValue:select_val,
            scene_options: scene_arr,
            scene_selectValue : [],
            bench_selectValue : [],
            remark:[],
            button_status : false,
        });

    };
    onSceneChange = (select_val) => {
        var bench_arr = [];
        var duplicate_label = [];
        if(select_val != null){
        for (var key in this.state.all_val['sceneval']){
            if (this.state.all_val.sceneval[key]===select_val.value){
                if (duplicate_label.length>0 && duplicate_label.includes(this.state.all_val.benchval[key])){
                    //pass
                }
                else{
                    bench_arr.push({value:this.state.all_val.benchval[key],label:this.state.all_val.benchlabel[key]})
                    duplicate_label.push(this.state.all_val.benchval[key])
                }
            }
        }
        }

        bench_arr.sort(function(first,second){
            return second.value -first.value;
        });


        this.setState({
            scene_selectValue : select_val,
            bench_selectValue : [],
            remark:[],
            button_status : false,
            bench_options : bench_arr,
        });

    };
   
    onBenchChange = (select_val) => {
        
        if(select_val != null){
            for (var key in this.state.all_val['benchval']){
                if (this.state.all_val.benchval[key]===select_val.value){
                    var bench_remark = this.state.all_val.remark[key]
                }
            }
        }
    
        this.setState({
            bench_selectValue : select_val,
            remark: bench_remark,
            button_status : true,
        });
        this.props.onDropdownSelect(select_val.value,this.state.scene_selectValue.value,this.state.tag_selectValue.value)

        
    };


    componentDidMount(){
        getIdValuesLvl2().then(res => {
             console.log(res)
            this.setState({
                all_val : res.data,
                tag_options : res.data.tag_options,
                tag_selectValue : res.data.tagval[-1],
                scene_selectValue : res.data.sceneval[-1],
                bench_selectValue : res.data.benchval[-1],
               
        });
    });
    }

    render() {

        return (
            <div data-test = 'dropdownLevel2Component'>
                <div className="row">
                    <div className="col-lg-3">
                        <label htmlFor="cars" style={{color: "#464646"}}>&nbsp;Version(Tag):</label>
                    </div>
                    <div className="col-lg-2">
                        <label htmlFor="cars" style={{color: "#464646"}}>&nbsp;Scene Group:</label>
                    </div>
                    <div className="col-lg-3">
                        <label htmlFor="cars" style={{color: "#464646"}}>&nbsp;Bench:</label>
                    </div>

                </div>
                <div className="row">
                    <div className="col-lg-3">
                        <VirtualizedSelect
                            options={this.state.tag_options}
                            onChange={(tag_selectValue) => this.onTagChange(tag_selectValue)}
                            value={this.state.tag_selectValue}
                        />
                    </div>
                    <div className="col-lg-2">
                        <VirtualizedSelect
                            options={this.state.scene_options}
                            onChange={(scene_selectValue) => this.onSceneChange(scene_selectValue)}
                            value={this.state.scene_selectValue}
                        />
                    </div>
                    <div className="col-lg-3">
                        <VirtualizedSelect
                            options={this.state.bench_options}
                            onChange={(bench_selectValue) => this.onBenchChange(bench_selectValue)}
                            value={this.state.bench_selectValue}
                        />
                    </div>
                   
                    <div className="col-lg-2">
                        <button className="btn" onClick={() => this.viewRemark()} disabled={!this.state.button_status}>
                            View Remark
                        </button>
                    </div>
                </div>
                <Modal visible={this.state.view_remark} width="400" height="400" effect="fadeInUp" onClickAway={() => this.closeModal()}>
                    <h1>Remarks</h1>
                    <ul>
                        <li style={{fontSize:30}}>{this.state.remark}</li>
                    </ul>

                </Modal>
                {this.state.view_advance_search ? <AdvanceSearchModal closeSearchModal = {this.onCloseAdvanceSearchModal.bind(this)} />:""}


            </div>

        )
    }
}
Dropdown_level2.propTypes={
onDropdownSelect:PropTypes.string,
//navigateHome:PropTypes.string,
}
Dropdown_level2.defaultProps= {
onDropdownSelect:[],
//navigateHome:[],
}
// onSceneChange = (select_val) => {
//     var bench_arr = [];
//     var duplicate_label = [];
//     if(select_val != null){
//     for (var key in this.state.all_val['sceneval']){
//         if (this.state.all_val.sceneval[key]===select_val.value){
//             if (duplicate_label.length>0 && duplicate_label.includes(this.state.all_val.benchval[key])){
//                 //pass
//             }
//             else{
//                 bench_arr.push({value:this.state.all_val.benchval[key],label:this.state.all_val.benchlabel[key]})
//                 duplicate_label.push(this.state.all_val.benchval[key])
//             }
//         }
//     }
//     }

//     bench_arr.sort(function(first,second){
//         return second.value -first.value;
//     });


//     this.setState({
//         scene_selectValue : select_val,
//         bench_selectValue : [],
//         remark:[],
//         button_status : false,
//         bench_options : bench_arr,
//     });

// };

// onBenchChange = (select_val) => {

//     if(select_val != null){
//         for (var key in this.state.all_val['benchval']){
//             if (this.state.all_val.benchval[key]===select_val.value){
//                 var bench_remark = this.state.all_val.remark[key]
//             }
//         }
//     }

//     this.setState({
//         bench_selectValue : select_val,
//         remark: bench_remark,
//         button_status : true,
//     });
//     this.props.onDropdownSelect(select_val.value,this.state.scene_selectValue.value,this.state.tag_selectValue.value)


// };

export default Dropdown_level2
